import { Users, TrendingUp, Flame, Phone, Package, FileText, BookOpen } from "lucide-react";

const StatCard = ({ label, value, subtitle, icon: Icon, iconColor, trend }) => (
  <div
    data-testid={`stat-card-${label.replace(/\s/g, '-')}`}
    className="bg-white dark:bg-[#1a231a] border border-[#2C3329]/10 dark:border-[#2a3a2a] rounded-sm p-4 sm:p-5 transition-all duration-200 hover:-translate-y-0.5 hover:border-[#2C3329]/25"
  >
    <div className="flex items-center justify-between mb-3">
      <span className="font-sans text-[11px] tracking-[0.05em] uppercase text-[#5C5C5C] dark:text-[#9A9790]">
        {label}
      </span>
      <div className={`p-1.5 rounded-sm ${iconColor}`}>
        <Icon className="h-3.5 w-3.5" />
      </div>
    </div>
    <div className="flex items-baseline gap-2">
      <span className="font-sans text-2xl sm:text-3xl font-semibold text-[#2C3329] dark:text-white leading-none">
        {value}
      </span>
      {trend !== undefined && (
        <span className={`text-xs font-medium ${trend >= 0 ? 'text-[#6B8E6B]' : 'text-[#C67D63]'}`}>
          {trend >= 0 ? '+' : ''}{trend}%
        </span>
      )}
    </div>
    {subtitle && (
      <p className="font-sans text-xs text-[#A3A3A3] mt-1.5">{subtitle}</p>
    )}
  </div>
);

export const DashboardStatsRow = ({ stats }) => {
  if (!stats) return null;

  const cards = [
    {
      label: "סה״כ משתמשים",
      value: stats.totalUsers,
      subtitle: `${stats.monthUsers} החודש`,
      icon: Users,
      iconColor: "bg-[#2C3329]/5 text-[#2C3329] dark:bg-[#4A5D43]/20 dark:text-[#6B8E6B]",
    },
    {
      label: "צמיחה שבועית",
      value: `${stats.weekUsers}`,
      subtitle: "נרשמו השבוע",
      icon: TrendingUp,
      iconColor: "bg-[#6B8E6B]/10 text-[#6B8E6B]",
      trend: stats.weeklyGrowth,
    },
    {
      label: "פעילים 24 שע'",
      value: stats.activeIn24h,
      subtitle: `מתוך ${stats.totalUsers}`,
      icon: Flame,
      iconColor: "bg-[#C67D63]/10 text-[#C67D63]",
    },
    {
      label: "עם טלפון",
      value: stats.withPhone,
      subtitle: `${stats.totalUsers > 0 ? Math.round((stats.withPhone / stats.totalUsers) * 100) : 0}% מהמשתמשים`,
      icon: Phone,
      iconColor: "bg-[#7B8C96]/10 text-[#7B8C96]",
    },
    {
      label: "קיבלו ערכה",
      value: stats.receivedKit,
      subtitle: `${stats.contacted} נוצר קשר`,
      icon: Package,
      iconColor: "bg-[#4A5D43]/10 text-[#4A5D43]",
    },
    {
      label: "הורדות PDF",
      value: stats.totalPdfDownloads,
      subtitle: `${stats.conversionRate}% המרה`,
      icon: FileText,
      iconColor: "bg-amber-700/10 text-amber-700 dark:text-amber-500",
    },
    {
      label: "קריאות מאמר",
      value: stats.articleReads ?? 0,
      subtitle: "לחיצות להרחבה (כללי)",
      icon: BookOpen,
      iconColor: "bg-[#C47F64]/10 text-[#C47F64]",
    },
  ];

  return (
    <div data-testid="admin-dashboard-stats" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 sm:gap-4 mb-6">
      {cards.map((card) => (
        <StatCard key={card.label} {...card} />
      ))}
    </div>
  );
};
